import { Container } from 'react-bootstrap';
import Layout from './Layout';
import './Error.css';

export type ErrorScreenProps = {
    onRetry: () => void;
    onCancel: () => void;
    error?: string;
}

const ErrorScreen = (props: ErrorScreenProps) => {
    return (
        <Layout
            footerContent={
                <div className="d-flex gap-2 justify-content-center">
                    <button
                        onClick={props.onCancel}
                        className="btn btn-outline-primary px-4 py-2"
                        style={{ maxWidth: window.innerWidth <= 576 ? '100%' : '150px', width: '100%' }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={props.onRetry}
                        className="btn btn-primary px-4 py-2"
                        style={{ maxWidth: window.innerWidth <= 576 ? '100%' : '150px', width: '100%' }}
                    >
                        Retry
                    </button>
                </div>
            }
        >
            <Container fluid className="text-center">
                <div className="error-container d-flex flex-column align-items-center justify-content-center">
                    <i className="bi bi-exclamation-circle error-icon"></i>
                    <h4 className="mb-3">Something went wrong</h4>
                    {props.error && <p className="text-danger">{props.error}</p>}
                </div>
            </Container>
        </Layout>
    );
}

export default ErrorScreen;